import * as React from 'react';
import { isEmpty } from 'ramda';
import { styled } from 'styled-components';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import { Button, Icon, tk, zIndex } from '@sunwebgroup/ui-components';

import { useLiveSearch } from '@/scopes/search/search/domain/live-search/hooks';
import * as LiveSearch from './Primitives';
import { useIntl } from '@/intl';

export const LiveSearchDesktop = () => {
  const intl = useIntl();
  const { data, isFetching, isLoading } = useLiveSearch();

  const [open, setOpen] = React.useState(false);

  const onOpenChange = React.useCallback(
    (newOpen: boolean) => {
      setOpen(newOpen);
    },
    [setOpen]
  );

  return (
    <PopoverPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <Trigger asChild>
        <Button $withoutColor $hierarchy="tertiary">
          <Icon glyph="IconSearch" />
        </Button>
      </Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content asChild align="start" avoidCollisions>
          <Content>
            <LiveSearch.Header />
            <BodyWrapper>
              <LiveSearch.Body />
              {!isFetching && !isLoading && !isEmpty(data) && data && (
                <Footer>
                  <Button $hierarchy="tertiary" $withoutColor onClick={() => onOpenChange(false)}>
                    {intl.formatMessage({ id: 'live-search_cancel' })}
                  </Button>
                </Footer>
              )}
            </BodyWrapper>
            <Wrapper>
              <LiveSearch.Loader />
              <LiveSearch.NoResults />
            </Wrapper>
          </Content>
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
};

const Trigger = styled(PopoverPrimitive.Trigger)`
  &:hover {
    color: ${tk('color_semantic_text_primary_hover')};
  }
`;

const BodyWrapper = styled.div`
  position: relative;
  &:not(:empty) {
    height: 100%;
    overflow-y: scroll;
    border: 2px solid ${tk('color_semantic_border')};
    border-radius: ${tk('radius_large')};
    margin: ${tk('spacing_md')};
    margin-top: 0;
    padding-top: ${tk('spacing_md')};
  }
`;

const Wrapper = styled.div`
  &:not(:empty) {
    margin: ${tk('spacing_md')};
    margin-top: 0;
  }
`;
const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: sticky;
  position: -webkit-sticky;

  width: 100%;
  bottom: 0;
  min-height: 50px;

  background: ${tk('color_semantic_bg')};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  max-height: 450px;
  width: 332px;
  min-width: 332px;

  background: ${tk('color_semantic_bg')};
  border-radius: ${tk('radius_large')};
  border: 2px solid ${tk('color_semantic_border')};
  box-shadow: ${tk('shadow_md_bottom')};
  margin-top: ${tk('spacing_2xs')};
  width: var(--radix-popover-trigger-width);

  outline: none;
  z-index: ${zIndex.modalOrMobilePopover};

  @media ${tk('mq_desktop_sm')} {
    z-index: ${zIndex.header};
  }
`;
